.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  padding: 32px 16px 16px;
}

.illustration {
  position: relative;
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mapCircle {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: radial-gradient(circle, #e8e8e4 0%, #d4d4cf 100%);
  opacity: 0.6;
}

.card {
  position: relative;
  transform: rotate(-6deg);
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.2));
}

.plusBadge {
  position: absolute;
  bottom: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #1e272f;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.text {
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: center;
  width: 100%;
}

.title {
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.2;
  color: var(--on-surface, #17181a);
  margin: 0;
}

.body {
  font-size: 16px;
  line-height: 22px;
  color: var(--on-surface-variant, #5d5d5f);
  margin: 0;
}

/* Payment type selector */

.selectorContent {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: var(--padding);
}

.selectorTitle {
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.2;
  color: var(--on-surface, #17181a);
  margin: 0;
}

.selectorList {
  display: flex;
  flex-direction: column;
}

.selectorRow {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 0;
  background: none;
  border: none;
  border-bottom: 1px solid rgba(23, 24, 26, 0.08);
  cursor: pointer;
  text-align: left;
  width: 100%;

  &:last-child {
    border-bottom: none;
  }
}

.rowIcon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.rowIconImg {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.selectorRowLabel {
  flex: 1;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 500;
  font-size: 17px;
  line-height: 22px;
  color: #17181a;
}
